import unescape from 'lodash/unescape';
import React from 'react';
import PropTypes from 'prop-types';
import Modal from '@spothero/ui/modal';
import ModalContent from '@spothero/ui/modal-content';

const DestinationInfoModalMobile = ({
    title,
    address,
    city,
    state,
    description,
    event,
    onHidden
}) => {
    const displayTitle = event.title || title;
    const displayDescription = event.description || description;

    return (
        <Modal
            className="DestinationInfoModal"
            title={<span>More Info</span>}
            onHidden={onHidden}
        >
            <ModalContent>
                <h2>{unescape(displayTitle)} Parking Information</h2>
                {event.date &&
                    <p>{event.date}</p>
                }
                <p>{address} {city}, {state}</p>
                <p dangerouslySetInnerHTML={{__html: displayDescription}} />
            </ModalContent>
        </Modal>
    );
};

DestinationInfoModalMobile.propTypes = {
    title: PropTypes.string,
    address: PropTypes.string,
    city: PropTypes.string,
    state: PropTypes.string,
    description: PropTypes.string,
    event: PropTypes.object,
    onHidden: PropTypes.func.isRequired
};

DestinationInfoModalMobile.defaultProps = {
    event: {}
};

export default DestinationInfoModalMobile;
